import gmx_zMixins         from '../../../../../includes/Jmixins/zMixins'

// Locally declared common Data-Props & SVG Drawing Support

import lmx_localData                  from '../primitives/localData.js'
import lmx_Events                     from './Events'
import lmx_Watching                   from './Watching'
import lmx_LocalValues                from './set_LocalValues'


import lmx_draw_Forms                 from './draw_Forms'
import lmx_draw_Options               from './draw_Options'
import lmx_draw_Pagination            from './draw_Pagination'
import lmx_Search                     from './Search'

import lmx_draw_SystemList            from './draw_SystemList'
import lmx_draw_3D_Boundary           from './draw_3D_Boundary'
import lmx_draw_Dashboard             from './draw_Dashboard'
import lmx_draw_Elements              from './draw_Elements'

import lmx_chartRouter                from './chart/chartRouter'
import lmx_cht_Chart                  from './chart/draw_Chart'
import lmx_cht_ChartCanvas            from './chart/draw_ChartCanvas'
import lmx_cht_Timeline               from './chart/draw_Timeline'
import lmx_cht_Donuts                 from './chart/draw_Donuts'

import lmx_PDF                        from './PDF.js'



export default {
  
  mixins: [
    gmx_zMixins, 

    // Local Mixins
    lmx_localData,
    lmx_Events,
    lmx_Watching,
    lmx_LocalValues,
    

    lmx_draw_Forms,
    lmx_draw_Options,
    lmx_draw_Pagination,
    lmx_Search,

    lmx_draw_SystemList,
    lmx_draw_3D_Boundary,
    lmx_draw_Dashboard,
    lmx_draw_Elements,
    
    lmx_chartRouter,
    lmx_cht_Chart,
    lmx_cht_ChartCanvas,
    lmx_cht_Timeline,
    lmx_cht_Donuts,
    
    lmx_PDF,

  ],

}
